import { supabase } from '../../supabaseClient'

export const signInAction = (form) => async (dispatch) => {
  try {
    const { username, password } = form

    if (!username || !password) {
      alert('Please enter both username and password.')
      return
    }

    // Query your Supabase users table directly
    const { data: user, error } = await supabase
      .from('users')
      .select('*')
      .eq('username', username.trim())
      .eq('password', password)
      .maybeSingle()

    if (error) {
      alert(error.message)
      return
    }

    if (!user) {
      alert('Incorrect username or password')
      return
    }

    // Generate a token and set localStorage to match your reducer's expectations
    const token = `user-token-${user.id}`
    localStorage.setItem('token', token)
    localStorage.setItem('isLoggedIn', 'true')

    dispatch({
      type: 'SIGNIN',
      data: { token, user }
    })

    window.location.reload()
  } catch (error) {
    console.error('Sign in error:', error)
  }
}

export const signUpAction = (form) => async (dispatch) => {
  try {
    const { username, password } = form

    if (!username || !password) {
      alert('Please enter both username and password.')
      return
    }

    // Check if username is already taken
    const { data: existingUser } = await supabase
      .from('users')
      .select('id')
      .eq('username', username.trim())
      .maybeSingle()

    if (existingUser) {
      alert('Username is already taken')
      return
    }

    // Insert new user into public.users table
    const { data: newUser, error } = await supabase
      .from('users')
      .insert([{ username: username.trim(), password: password }])
      .select()
      .single()

    if (error) {
      alert(error.message)
      return
    }

    const token = `user-token-${newUser.id}`
    localStorage.setItem('token', token)
    localStorage.setItem('isLoggedIn', 'true')

    dispatch({
      type: 'SIGNUP',
      data: { token, user: newUser }
    })

    window.location.reload()
  } catch (error) {
    console.error('Sign up error:', error)
  }
}

export const logoutAction = () => (dispatch) => {
  try {
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('token')
    dispatch({ type: 'LOGOUT' })
    window.location.reload()
  } catch (error) {
    console.error('Logout error:', error)
  }
}
